/* CLOUDWEB-18216 Эксперимент: разворачивание / сворачивание пункта "Все файлы" только по стрелке */

import { isFeature } from 'Cloud/Application/FeaturesEs6';
import { IS_B2B_BIZ_USER } from 'reactApp/appHelpers/configHelpers';

export const isScrollTopBtnEnabled: boolean = !IS_B2B_BIZ_USER && isFeature('scroll-top-btn');
